module.exports = "<div *ngIf=\"message\" [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', \n'alert-danger': message.type === 'error' }\">\n    {{message.text}}</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/directives/alert.component.html
// module id = ../../../../../src/app/directives/alert.component.html
// module chunks = main